@if (profileDataKeys && profileDataModeled) {
  <div class="your-data-container">
    @if (isSecondProfile) {
      <div class="banner-data">
        <span class="info-circle" nz-icon nzType="info-circle" nzTheme="fill"></span>
        <p>
          {{'personalArea.view' | translate}} <b>{{ profileDataModeled?.name?.value }}</b
          >, {{'personalArea.click_here' | translate}} <a (click)="changeUser()">{{'personalArea.here' | translate}}</a>
        </p>
      </div>
    }
    <div class="title-divider">
      <h2>{{ 'personalArea.myData.my_profile' | translate }}</h2>
      <nz-divider></nz-divider>
    </div>
    <!-- TODO Questo può diventare un componente separato da riutilizzare anche sotto -->
    <div class="content-bar-container">
      <div class="content-container">
        @for (key of profileDataKeys; track key) {
          <div class="info-container">
            @if (!profileDataModeled[key].isEditable) {
              <span>{{ 'personalArea.myData.' + key | translate }}</span>
              <p>{{ profileDataModeled[key].value }}</p>
            } @else {
              <div class="editable-field">
                <ds-input-text
                  [control]="findControl(key)"
                  [placeholder]="'personalArea.myData.insert' | translate"
                  [label]="'personalArea.myData.' + key | translate"
                  [readonlyMode]="!editingMode"
                ></ds-input-text>

                @if (key === 'telephone' && profileDataModeled.telephone.isPhoneCertified) {
                  <div class="phone-certified">
                    <span nz-icon nzType="check-circle" nzTheme="fill" class="certified-icon"></span>
                    <span class="certified-text">{{ 'personalArea.myData.phone_certified' | translate }}</span>
                  </div>
                }
              
                @if (
                  editingMode &&
                  (key === 'email' || key === 'telephone') &&
                  findControl(key)?.invalid
                ) {
                  <div class="error-message">
                    @if (findControl(key)?.hasError('required')) {
                      <span class="error-text">Il campo è obbligatorio</span>
                    }
                    @if (key === 'email' && findControl(key)?.hasError('email')) {
                      <span class="error-text">Inserisci un indirizzo email valido</span>
                    }
                    @if (key === 'telephone' && findControl(key)?.hasError('pattern')) {
                      <span class="error-text">Inserisci un numero di telefono valido</span>
                    }
                  </div>
                }
              </div>              
            }
          </div>
        }
      </div>
      <div class="bar-container">
        @if (!editingMode) {
          <ds-button class="button-edit" [text]="'buttons.edit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="editingMode = !editingMode"></ds-button>
        } @else {
          <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="editingMode = !editingMode"></ds-button>
          <ds-button class="button-save" [text]="'buttons.save' | translate" [width]="'small'" (click)="onSave()" [isDisabled]="formData.invalid"></ds-button>
        }
      </div>
    </div>
    @if (!isSecondProfile) {
      <div class="title-divider">
        <h2>
          {{ !disabledMFA
            ? ('personalArea.myData.change_password_MFA' | translate)
            : ('personalArea.myData.change_password' | translate) }}
        </h2>
        <nz-divider></nz-divider>
      </div>

      <div>
        <app-change-password></app-change-password>
      </div>
    <div *ngIf="!user.functions.includes('MCE')">
      <div class="title-divider">
        <h2>{{ 'personalArea.myData.info_policy' | translate }}</h2>
        <nz-divider></nz-divider>
      </div>

      <div class="content-bar-container">
        <div class="content-container">
          <div class="info-container">
            <span>{{ 'personalArea.myData.policy_name' | translate }}</span>
            <p>{{ profileData?.product?.name }}</p>
          </div>
          <div class="info-container">
            <span>{{ 'personalArea.myData.decurrency_date' | translate }}</span>
            <p>{{ profileData?.product?.activationDate | date: 'dd/MM/yyyy' }}</p>
          </div>
          <div class="info-container">
            <span>{{ 'personalArea.myData.expiration_date' | translate }}</span>
            <p>{{ profileData?.product?.expirationDate | date: 'dd/MM/yyyy' }}</p>
          </div>
        </div>
        <div class="bar-container">
          @if (policyUrl) {
            <ds-button
              [iconRight]="'/public/assets/images/icon-right-blue.svg'"
              [text]="'buttons.other_details' | translate"
              [styleType]="'undressed-main'"
              [width]="'small'"
              (click)="onOtherDetails()"
            ></ds-button>
          }
        </div>
      </div>
    </div>
    }
  </div>
}
